import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Home, Car, ShoppingBag, Wrench, Users, Heart, Calendar, GraduationCap } from 'lucide-react';
import { Card } from './ui/Card';
const categories = [{
  name: 'Jobs',
  icon: Briefcase,
  count: '2,847',
  color: 'bg-blue-100 text-blue-600'
}, {
  name: 'Real Estate',
  icon: Home,
  count: '1,523',
  color: 'bg-green-100 text-green-600'
}, {
  name: 'Vehicles',
  icon: Car,
  count: '986',
  color: 'bg-orange-100 text-orange-600'
}, {
  name: 'For Sale',
  icon: ShoppingBag,
  count: '4,215',
  color: 'bg-purple-100 text-purple-600'
}, {
  name: 'Services',
  icon: Wrench,
  count: '1,892',
  color: 'bg-gray-100 text-gray-600'
}, {
  name: 'Community',
  icon: Users,
  count: '743',
  color: 'bg-yellow-100 text-yellow-600'
}, {
  name: 'Personals',
  icon: Heart,
  count: '1,156',
  color: 'bg-pink-100 text-pink-600'
}, {
  name: 'Events',
  icon: Calendar,
  count: '428',
  color: 'bg-red-100 text-red-600'
}, {
  name: 'Classes',
  icon: GraduationCap,
  count: '634',
  color: 'bg-indigo-100 text-indigo-600'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function CategoryGrid() {
  return <section className="py-12 bg-white" data-id="element-33">
      <div className="container mx-auto px-4" data-id="element-34">
        <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center md:text-left" data-id="element-35">
          Browse Categories
        </h2>

        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-36">
          {categories.map(cat => <motion.div key={cat.name} variants={item} data-id="element-37">
              <Card className="h-full hover:shadow-md transition-all duration-200 cursor-pointer border-gray-200 group hover:border-[#00897B]/30 hover:scale-[1.02]" data-id="element-38">
                <div className="p-4 flex flex-col items-center text-center h-full justify-center gap-3" data-id="element-39">
                  <div className={`p-3 rounded-full ${cat.color} group-hover:scale-110 transition-transform duration-200`} data-id="element-40">
                    <cat.icon className="h-6 w-6" data-id="element-41" />
                  </div>
                  <div data-id="element-42">
                    <h3 className="font-semibold text-gray-900 group-hover:text-[#00897B] transition-colors" data-id="element-43">
                      {cat.name}
                    </h3>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-44">
                      {cat.count} ads
                    </p>
                  </div>
                </div>
              </Card>
            </motion.div>)}

          {/* View All Card */}
          <motion.div variants={item} data-id="element-45">
            <Card className="h-full hover:shadow-md transition-all duration-200 cursor-pointer border-dashed border-gray-300 bg-gray-50 hover:bg-gray-100 hover:border-gray-400 group" data-id="element-46">
              <div className="p-4 flex flex-col items-center text-center h-full justify-center gap-2" data-id="element-47">
                <span className="text-sm font-medium text-gray-600 group-hover:text-gray-900" data-id="element-48">
                  View All Categories
                </span>
                <span className="text-xs text-gray-400" data-id="element-49">More...</span>
              </div>
            </Card>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}